import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import DiscoveryListController, { queryParams } from "discourse/controllers/discovery/list";
export default class TagsIntersectionController extends DiscoveryListController {
  constructor() {
    super(...arguments);
    _defineProperty(this, "queryParams", [...Object.keys(queryParams), {
      categoryParam: "category"
    }]);
  }
}